export {
  InputField,
  type InputFieldProps,
  InputFieldError,
  type InputFieldErrorProps,
  InputFieldLabel,
  type InputFieldLabelProps,
  InputFieldNote,
  type InputFieldNoteProps,
} from '../../compositions/shared/InputField';
